module.exports = __webpack_public_path__ + "fonts/GeogrotesqueCyr-Medium.03209e4c.eot";